import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PDFViewer from "../viewer/PDFViewer";
import BoxViewer from "../viewer/BoxViewer";
import { IntlProvider } from "react-intl";

/*

fileOptions info:
    https://github.com/box/box-ui-elements/blob/master/src/elements/content-preview/README.md

    Note: Any other option listed here https://github.com/box/box-content-preview#parameters--options,
    which is also not listed or overridden above as a prop, will be passed on as-is to the Preview Library.

    https://github.com/box/box-content-preview#parameters--options

 */
const Preview = (props) => {
    const [boxViewer, setBoxViewer] = useState(
        process.env.REACT_APP_USE_PDF_VIEWER === "false" || process.env.REACT_APP_USE_PDF_VIEWER === false
    );
    const [mountBoxViewer, setMountBoxViewer] = useState(true);
    const [pageNumber] = useState(props.pageNumber);
    const [snippet] = useState(props.snippet);

    window.location.pathname.toLowerCase().includes("debug") && console.log('preview props = ', props);

    const handleChangeViewer = () => {
        setBoxViewer(!boxViewer);
    };

    const unmountBoxViewer = () => {
        setMountBoxViewer(false);
    };

    const remountBoxViewer = () => {
        setMountBoxViewer(true);
    };

    const actionsConfig = props.actionsConfig;
    const actionConfig = actionsConfig && actionsConfig.previewDocument;

    const usePdfViewer = process.env.REACT_APP_USE_PDF_VIEWER === "true"
        || process.env.REACT_APP_USE_PDF_VIEWER === true
        || props.viewer === "PDFViewer";

    const pdfViewerGetContent = usePdfViewer && actionConfig && actionConfig.pdfViewer && actionConfig.pdfViewer.getContent;

    const openUrl = process.env.REACT_APP_DOCUMENT_SOURCE === "sharepoint"

    // console.log ('render Preview.js props=', props)
    // console.log ('render Preview.js usePdfViewer', usePdfViewer)
    // console.log ('render Preview.js actionConfig=', actionsConfig)

    return (
        <div style={{ height: '100%', width: '100%' }}>

            {/*{*/}
            {/*    (process.env.REACT_APP_USE_PDF_VIEWER === "true" || process.env.REACT_APP_USE_PDF_VIEWER === true) &&*/}

            {/*    <FormControlLabel*/}
            {/*        style={{paddingLeft: '16px'}}*/}
            {/*        control={*/}
            {/*            <Switch*/}
            {/*                checked={boxViewer}*/}
            {/*                onChange={handleChangeViewer}*/}
            {/*                value="boxViewer"*/}
            {/*                color="primary"*/}
            {/*                inputProps={{'aria-label': 'primary checkbox'}}*/}
            {/*            />*/}
            {/*        }*/}
            {/*        label="Box Viewer"*/}
            {/*    />*/}
            {/*}*/}

            {/*{*/}
            {/*    openUrl &&*/}
            {/*    <iframe src = {props.fileUrl}/>*/}
            {/*}*/}

            {usePdfViewer ? (
                <PDFViewer
                    fileContent={props.fileContent}
                    fileUrl={props.fileUrl}
                    getContent={pdfViewerGetContent}
                    userDetails={props.userDetails}
                    pageNumber={pageNumber || null}
                    snippet={snippet || null}
                    //triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                    boxDocID={props.boxDocID}
                />
            ) : (
                mountBoxViewer && (
                    <IntlProvider locale="en">
                        <BoxViewer
                            boxDocID={props.boxDocID}
                            userDetails={props.userDetails}
                            pageNumber={props.pageNumber}
                            showHeader={props.showHeader}
                            actionsConfig={props.actionsConfig}
                            showSidebar={props.showSidebar}
                            unmountComponent={unmountBoxViewer}
                            remountComponent={remountBoxViewer}
                            preventOpen={props.preventOpen}
                        />
                    </IntlProvider>
                )
            )}
        </div>
    );
};

Preview.propTypes = {
    boxDocID: PropTypes.string,//.isRequired,
    fileContent: PropTypes.string,
    fileUrl: PropTypes.string,
    userDetails: PropTypes.object.isRequired,
    pageNumber: PropTypes.number,
    showHeader: PropTypes.bool.isRequired,
    actionsConfig: PropTypes.object.isRequired,
    showSidebar: PropTypes.bool,
    triggerRefreshAuthToken: PropTypes.func.isRequired,
    unmountComponent: PropTypes.func, //only required from Watson dialog to facilitate switching pages with ContentPreview (box viewer)
    remountComponent: PropTypes.func, //only required from Watson dialog to facilitate switching pages with ContentPreview (box viewer)
    preventOpen: PropTypes.bool,  //prevent opening when used in SelectTemplateDialog
    viewer: PropTypes.string
};

export default Preview;
